import { useEffect } from "react";

const TRUST_ITEMS = [
  { icon: "ri-award-fill", label: "Over 25 Years of Experience" },
  { icon: "ri-checkbox-multiple-line", label: "450-Point Bumper-to-Bumper Inspection" },
  { icon: "ri-shield-star-fill", label: "BBB Accredited Business" },
  { icon: "ri-user-voice-line", label: "Direct Inspector Consultation" },
  { icon: "ri-price-tag-3-fill", label: "Starting at $139" },
];

export default function TrustBar() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("lp-visible"); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll(".lp-reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-brand-dark border-y border-brand-gold/15">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-wrap justify-center lg:justify-between items-center divide-y lg:divide-y-0 lg:divide-x divide-brand-gold/12">
          {TRUST_ITEMS.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 py-4 px-5 lg:flex-1 justify-center"
            >
              <div className="w-7 h-7 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-brand-gold text-lg`} />
              </div>
              <span className="font-sans text-xs font-medium text-brand-gray-light whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
